export const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const isValidPhone = (value) => {
  var str = value || "";
  var digits = str.replace(/\D/g, "");
  return digits.length === 0 || digits.length === 10;
};

export const isValidEmailField = (value) => {
  return !value || (value.length > 0 && validateEmail(value));
};
